import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import { ethers } from "ethers";
import styled from "styled-components";
import Web3 from "web3";
import Web3EthContract from "web3-eth-contract";
import {
  Card,
  View,
  StyleSheet,
  Text,
  Linking
} from 'react-native';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { BrowserView, MobileView } from "react-device-detect";
import Table from 'react-bootstrap/Table';
import abi from './nftabi.json';
import Nftpuller from './n2dpuller/nftpuller'



const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
font-family:"Corbel";
 border-color:#FFFFFF;
  border-radius: 7px;
  border-style:solid;
  border-width:1px;
  background-image:linear-gradient(to right, rgba(26,72,253,1) 40%, rgba(252,252,252,0.2) 100%);
  background-color: #1A48FD;
   padding: 10px;
  font-weight: bold;
  color: var(--primary);
  width: 150px;
  cursor: pointer;
  box-shadow: 0px 4px 0px -2px rgba(10, 10, 10, 0.4);
  -webkit-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
  -moz-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
  // :hover {
  //   transition-duration: 1.4s; 
  //   background:radial-gradient(farthest-corner at 10px 10px,
  //     #000000 50%,  #323232 90%);
  //   border: 2px solid #323232;
`;
export const StyledButton2 = styled.button`
font-family:"Corbel";
  padding: 5px;
  border-radius: 50px;
  border: 2px solid white;
  background-color: #000000;
  padding: 10px;
  font-weight: 900;
  font-size: 100%;
  color: var(--button2);
  width: 150px;
  cursor: all-scroll;
  box-shadow: 0px 4px 0px -2px rgba(10, 10, 10, 0.4);
  -webkit-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
  -moz-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
  :hover {
    transition-duration: .4s; 
    background-color: #323232;
    border: 2px solid #323232;
  }
  @media (min-width: 90px) {
    width: 75px;
    justify-content: start;
  }
  @media (min-width: 900px) {
    width: 150px;
  }
`;
export const StyledButton3 = styled.button`
  padding: 5px;
  border-radius: 50px;
  border: 2px solid white;
  background-color: #ffffff;
  padding: 10px;
  font-weight: 900;
  font-size: 100%;
  color: var(--secondary);
  width: 150px;
  cursor: all-scroll;
  box-shadow: 0px 4px 0px -2px rgba(10, 10, 10, 0.4);
  -webkit-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
  -moz-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
  :hover {
    transition-duration: .4s; 
    background-color: #323232;
    border: 2px solid #323232;
    color: white;
  }
`;


export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: #3B04A0;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 15px 0px -2px rgba(200, 200, 200, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(200, 200, 200, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(200, 200, 200, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 9
  0%;
  align-self: center;
  @media (min-width: 367px) {
    flex-direction: row;
  }
`;






export const ResponsiveWrapperHeader = styled.div`

display:flex;
  width: 100%;
  flex-direction: row;
  
  background-color:rgba(3, 182, 247, 0.2);


  
`;

export const StyledLogo = styled.img`
  display: inline;
  width: 200px;
  @media (max-width: 767px) {
    width: 200px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledLogo2 = styled.img`
  width: 200px;
  
  @media (min-width: 767px) {
    width: 500px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const LogoDiv = styled.div`
display: flex;
align-items: center;
justify-content: center;
align-content: center;
gap: 10%;
width: 300px;
`;

export const StyledImg = styled.img`
  width: 150px;
`;
export const StyledImgForCard = styled.img`
  width: 500px;
`;
export const StyledImgYours = styled.img`
  width: 100%;
`;
export const StyledImgTitle = styled.img`
  width: 300px;
`;
export const StyledImgSpinningCoin = styled.img`
  width: 200px;
`;
export const StyledImgSpinningCoin2 = styled.img`
  width: 150px;
  cursor:pointer;
`;

export const StyledLink = styled.a`
color: Blue;
text-decoration: none;
margin: 1rem;
position: relative;
@media (min-width: 67px) {
  width: 20px;
  font-family: 'Corbel', sans-serif;
  
}
`;

export const StyledHR = styled.hr`
  border: 2px solid white;  
  background-color: white;
  border-radius: 2px;
  width: 400px;
  @media (max-width: 567px) {
    width: 250px;
  }
`;


export const WalletBox = styled.div`
font-family:"Corbel";
border-color:#FFFFFF;
border-radius: 7px;
border-style:solid;
border-width:1px;
// background-image:linear-gradient(to right, rgba(26,72,253,1) 40%, rgba(252,252,252,0.2) 100%);
// background-color: #1A48FD;

 padding: 10px;
font-weight: bold;
color: var(--primary);
width: auto;
cursor: pointer;
// box-shadow: 0px 4px 0px -2px rgba(10, 10, 10, 0.4);
// -webkit-box-shadow: 0px 5px 0px 1px rgba(10, 10, 10, 0.5);
// -moz-box-shadow: 0px 5px 0px -2px rgba(10, 10, 10, 0.5);
// :hover {
//   transition-property: all;
//   transition-timing-function:ease-in-out  ;
//   transition-duration: .2s; 
//   background-color: #1A48FD;
//   border: 1px solid black;
//   background-image:linear-gradient(to left, rgba(26,72,253,1) 40%, rgba(252,252,252,0.2) 100%);
// background-color: #1A48FD;
// }


`;






function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [walletAddress, setAddress] = useState("Connect Wallet");
  const [claimingNft, setClaimingNft] = useState(false);
  const [StakeNFT, setStakeNFT] = useState(false);
  const [UnStakeNFT, setUnStakeNFT] = useState(false);
  const [UnStakeAllNFT, setUnStakeAllNFT] = useState(false);
  const [ClaimReward, setClaimReward] = useState(false);

  const [claimNft, setClaimNft] = useState(false);
  const [feedbackMint, setFeedbackMint] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [TotalSupply, setTotalSupply] = useState(0);
  const [visible, setVisible] =  useState(false);
  const [CheckReward, setCheckReward] = useState(false);
  const [CheckIDS, setCheckIDS] = useState(false);
  const [buttonText, setButtonText] = useState('Connect Wallet');
  const [feedback, setFeedback] = useState(`Approve The Contract For Staking`);
  const [isApproved, setisApproved] = useState(false);
  const [StakeMSG, setMSG] = useState(null);
  const [UnStakeAllMSG, setUnStakeAllMSG] = useState(null);
  const [UnStakeMSG, setUnMSG] = useState(null);
  const [HavestMSG, setHarvestMSG] = useState(null);
  const [RewardMSG, setRewardMSG] = useState(null);
  const [CheckMSG, setCheckMSG] = useState(null);
  const [tokens, settokens] = useState();
  const tokensInputRef = useRef();

  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    TOKEN:"",
    SCAN_LINK: "",
    NFT_SCAN_LINK:"",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    GAS_LIMIT: 0,
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    WHITELIST_COST: 0,
    DISPLAY_COST: 0,
    NFT_GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

const mintAddress = "0xBaAe8ace96915D2988CdEcd520E3C67769239627";
const mintABI =  [{
  "inputs": [
    {
      "internalType": "address",
      "name": "_to",
      "type": "address"
    },
    {
      "internalType": "uint256",
      "name": "_mintAmount",
      "type": "uint256"
    }
  ],
  "name": "mint",
  "outputs": [],
  "stateMutability": "payable",
  "type": "function"
}];
;
const mintContract = new Web3EthContract(mintABI, mintAddress, blockchain.account);

const gettotalsupply = () => {
  Web3EthContract.setProvider("https://bsc-dataseed.binance.org/");
  let web3 = new Web3("https://bsc-dataseed.binance.org/");
  let abi = [{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"string","name":"_initBaseURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"uint256","name":"_mintAmount","type":"uint256"}],"name":"OwnerPreMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseExtension","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cost","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxMintAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_mintAmount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"_state","type":"bool"}],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"removeWhitelistUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_newBaseExtension","type":"string"}],"name":"setBaseExtension","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_newBaseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newCost","type":"uint256"}],"name":"setCost","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newmaxMintAmount","type":"uint256"}],"name":"setmaxMintAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"walletOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"whitelistUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"whitelisted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"payable","type":"function"}];
  const SmartContract= new Web3EthContract(
    abi,
   '0xBaAe8ace96915D2988CdEcd520E3C67769239627'
  );
  SmartContract.methods.totalSupply().call()
  .then((receipt) => {
    console.log("TotalSupply:", receipt);
    setTotalSupply(receipt);
    });
  };


  const claimWhiteListNFTs = () => {
  
    let cost = CONFIG.WHITELIST_COST;
    let gasLimit = CONFIG.NFT_GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedbackMint(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    mintContract.methods
      .mint(blockchain.account, mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
        to: CONFIG.TOKEN,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedbackMint('Sorry, something went wrong please try again.');
        setClaimingNft(false);
        window.location.reload(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedbackMint(
          "Congrats, you now own a SafeOne Lifetime Insurance NFT!!!"
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };







  const claimNFTs = () => {
  
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.NFT_GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedbackMint(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    mintContract.methods
      .mint(blockchain.account, mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        maxPriorityFeePerGas: null,
        maxFeePerGas: null,
        to: CONFIG.TOKEN,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedbackMint('Sorry, something went wrong please try again.');
        setClaimingNft(false);
        window.location.reload(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedbackMint(
          "Congrats, you now own a SafeOne Lifetime Insurance NFT!!!"
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };
  
  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 50) {
      newMintAmount = 50;
    }
    setMintAmount(newMintAmount);
  };


  const Approve = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit);
    setFeedback(`Approving your Staking...`);
    setClaimingNft(true);
    blockchain.smartToken.methods
    .setApprovalForAll(CONFIG.CONTRACT_ADDRESS, true)
    .send({
      to: CONFIG.TOKEN,
      from: blockchain.account,
    })


      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
        
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `You can Now Stake Your NFT`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };


  const Stake = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit);
    console.log("Gas limit: ", totalGasLimit);
    setMSG(`Staking your ${CONFIG.SYMBOL} #${tokens}...`);
    setStakeNFT(true);
    blockchain.smartContract.methods
      .deposit([tokens])
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
      })

      .once("error", (err) => {
        console.log(err);
        setMSG("Sorry, Something Went Wrong");
        setStakeNFT(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setMSG(
          `You Succesfully Staked Your ${CONFIG.NFT_NAME} `
        );
        setStakeNFT(false);
        dispatch(fetchData(blockchain.account));
      });
  };
  

  const StakeAll = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    setMSG(`Staking All of your SAFO NFTs...`);
    setStakeNFT(true);
    blockchain.smartToken.methods
    .walletOfOwner(blockchain.account)
    .call()
    .then((receipt) => {
      console.log("Token Ids of User", receipt);
      let TokenidofUser = receipt;
      let totalGasLimit = String(gasLimit * TokenidofUser.length);
    blockchain.smartContract.methods
      .deposit(TokenidofUser)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
      })
      .once("error", (err) => {
        console.log(err);
        setMSG("Sorry, Something Went Wrong");
        setStakeNFT(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setMSG(
          `You Succesfully Staked Your ${CONFIG.NFT_NAME} `
        );
        setStakeNFT(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const unstakeallnfts = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    setUnStakeAllMSG(`Unstaking All of your NFTs...`);
    setUnStakeAllNFT(true);
    blockchain.smartContract.methods
    .depositsOf(blockchain.account)
    .call({
      from: blockchain.account,
    })
    .then((receipt) => {
      console.log(receipt);
      setCheckMSG(
        `TokenID #${receipt}`
      );
      let TID = receipt;
      setCheckIDS(false);
      dispatch(fetchData(blockchain.account));
      let totalGasLimit = String(gasLimit * TID.length);
    blockchain.smartContract.methods
    .withdraw(TID)
    .send({
      gasLimit: String(totalGasLimit),
      to: CONFIG.CONTRACT_ADDRESS,
      from: blockchain.account,
    })
      .once("error", (err) => {
        console.log(err);
        setUnStakeAllMSG("Sorry, something went wrong please try again later.");
        setClaimReward(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setUnStakeAllMSG(
          `All of Your NFTs are Unstaked`
        );
        setClaimReward(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

  const UnStake = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit);
    console.log("Gas limit: ", totalGasLimit);
    setUnMSG(`UnStaking your ${CONFIG.SYMBOL} #${tokens}...`);
    setUnStakeNFT(true);
    blockchain.smartContract.methods
      .withdraw([tokens])
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
      })

      .once("error", (err) => {
        console.log(err);
        setUnMSG("Sorry, you have reached your wallet limit");
        setUnStakeNFT(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setUnMSG(
          `You Succesfully UnStaked ${CONFIG.SYMBOL} #${tokens}`
        );
        setUnStakeNFT(false);
        dispatch(fetchData(blockchain.account));
      });
  };




  const Harvest = () => {
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalGasLimit = String(gasLimit);
    setHarvestMSG(`Claiming your Rewards...`);
    setClaimReward(true);
    blockchain.smartContract.methods
    .depositsOf(blockchain.account)
    .call({
      from: blockchain.account,
    })
    .then((receipt) => {
      console.log(receipt);
      setCheckMSG(
        `TokenID #${receipt}`
      );
      let TID = receipt;
      setCheckIDS(false);
      dispatch(fetchData(blockchain.account));
    
    blockchain.smartContract.methods
    .claimRewards(TID)
    .send({
      to: CONFIG.CONTRACT_ADDRESS,
      from: blockchain.account,
    })
      .once("error", (err) => {
        console.log(err);
        setHarvestMSG("Sorry, something went wrong please try again later.");
        setClaimReward(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setHarvestMSG(
          `Rewards Harvested`
        );
        setClaimReward(false);
        dispatch(fetchData(blockchain.account));
      });
    });
  };

// wallet balance!!!
  let provider;
  let signer;
  let signerAddress;
  
  const lunaContractAddress = "0xd57Cfb45347573f4F2471fA1572Eb79d0Ba29Fd0"; //this is the dapp owners coin
  const recesionCoinAddress = "0x6a59e047Bd8AFa31a175B2056b44D1235AD4D852";
  const busdAddress = "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c";
  const tokenABI = [
    // balanceOf
    {
      "constant":true,
      "inputs":[{"name":"_owner","type":"address"}],
      "name":"balanceOf",
      "outputs":[{"name":"balance","type":"uint256"}],
      "type":"function"
    },
    // decimals
    {
      "constant":true,
      "inputs":[],
      "name":"decimals",
      "outputs":[{"name":"","type":"uint8"}],
      "type":"function"
    }
  ];
  let lunaContract;
  // let recessionContract;
  let lunaTokenBalance;
  // let recessionTokenBalance;
  let busdContract;
  let busdTokenBalance;
  
  













  
  const startFunction = async () => {
      //Connect to MetaMask
      await ethereum.request({ method: 'eth_requestAccounts'});
      //get provider
      provider = new ethers.providers.Web3Provider(window.ethereum);
      //get signer (I usually use signer because when you connect to contract via signer,
      //you can write to it too, but via provider, you can only read data from contract)
      signer = provider.getSigner();
      //Get connected wallet address
      signerAddress = await signer.getAddress();
      
//luna
      lunaContract = await new ethers.Contract(lunaContractAddress , tokenABI , signer);
     lunaTokenBalance = await lunaContract.balanceOf(signerAddress);
      //Note that userTokenBalance is not a number and it is bigNumber
      lunaTokenBalance = parseInt(lunaTokenBalance);
  lunaTokenBalance = lunaTokenBalance / Math.pow(10, 9);
      console.log(lunaTokenBalance);
  document.getElementById("luna").innerText = lunaTokenBalance;

//recession coin
  // recessionContract = await new ethers.Contract(recesionCoinAddress, tokenABI, signer);
  // recessionTokenBalance = await recessionContract.balanceOf(signerAddress);
  // recessionTokenBalance = parseInt(recessionTokenBalance);
  // recessionTokenBalance = recessionTokenBalance / Math.pow(10, 18);
  // console.log(recessionTokenBalance);
  // document.getElementById("recession").innerText = recessionTokenBalance;

  //busd
busdContract = await new ethers.Contract(busdAddress, tokenABI, signer);
busdTokenBalance = await busdContract.balanceOf(signerAddress);
busdTokenBalance = parseInt(busdTokenBalance);
busdTokenBalance = busdTokenBalance / Math.pow(10,18);
console.log(busdTokenBalance);
document.getElementById("busd").innerText = busdTokenBalance;
  checktotalsupply();
  }









const checktotalsupply = () => {
  Web3EthContract.setProvider("https://bsc-dataseed.binance.org/");
  let web3 = new Web3("https://bsc-dataseed.binance.org/");
  let abi = [{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"string","name":"_initBaseURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"uint256","name":"_mintAmount","type":"uint256"}],"name":"OwnerPreMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseExtension","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"cost","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxMintAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_mintAmount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"_state","type":"bool"}],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"removeWhitelistUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_newBaseExtension","type":"string"}],"name":"setBaseExtension","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"_newBaseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newCost","type":"uint256"}],"name":"setCost","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newmaxMintAmount","type":"uint256"}],"name":"setmaxMintAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"walletOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"whitelistUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"whitelisted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"payable","type":"function"}];
  const SmartContract= new Web3EthContract(
    abi,
   '0xBaAe8ace96915D2988CdEcd520E3C67769239627'
  );
  SmartContract.methods.balanceOf(signerAddress).call()
  .then((receipt) => {
    console.log("NFTs:", receipt);

    document.getElementById("nft").innerText = receipt
  
    });
  };









  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null){ { startFunction()};
      dispatch(fetchData(blockchain.account));
      setAddress(blockchain.account.substring(0,4) + "..." + blockchain.account.substring(38,42));

      blockchain.smartContract.methods
      .depositsOf(blockchain.account)
      .call({
        from: blockchain.account,
      })
      .then((receipt) => {
        let TOTALS = receipt;
        setCheckMSG(
          `#${receipt}`
        );
        blockchain.smartContract.methods
        .calculateRewards(blockchain.account, TOTALS)
        .call({
          from: blockchain.account,
        })
        .then((receipt) => {
          let ALLo = receipt.map(RW => {
            return (
              String(RW) / 1e18
            )
          });
          function sum(input){
            if (toString.call(input) !== "[object Array]")
               return false;
                       var total =  0;
                       for(var i=0;i<input.length;i++)
                         {                  
                           if(isNaN(input[i])){
                           continue;
                            }
                             total += Number(input[i]);
                            
                          }
                        return total;
                       }
          console.log("TOTAL REWARD", Number(sum(ALLo)/1000).toLocaleString('en-US'));
           setRewardMSG(
            `${Number(sum(ALLo)).toLocaleString('en-US', { minimumFractionDigits: 9 })}`
           );
        });
      });


      blockchain.smartToken.methods
      .isApprovedForAll(blockchain.account, CONFIG.CONTRACT_ADDRESS)
      .call({
        to: CONFIG.TOKEN,
        from: blockchain.account,
      })
        .then((receipt) => {
          console.log(receipt);
          setisApproved(true);
        });

    }
  }
  ;


  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
    gettotalsupply();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  function hide(){
    var x = document.getElementById("mobileimg");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }


{/*this is where the new function calling a second balance lives and starts it ends on line 687
line 720 is where the button is that calls this function
but i dont want to use the damn button. i couldnt figure out a second useState with this function so i tried to just have the first function call it. see line 708... it worked a few times but most of the time it breaks. very strange. */}


let accounts = blockchain.account
  
//end of new function
  
//this is the function you got to work using useState
 
const checkEth = async () => {
  if (accounts == null) {
    document.getElementById("bal").innerText = ("Please Connect Wallet" )   
  }
  else{
    let balance = await ethereum.request({method: 'eth_getBalance',
params: [
  accounts
]
}).catch((err) => {
  console.log(err);
});
console.log(accounts);
balance = parseInt(balance);
balance = balance / Math.pow(10, 18);
document.getElementById("bal").innerText = balance 
console.log(balance)

// getAccountBalance()
 }}


  useEffect (() => {
  checkEth()
}, [accounts])



function handleClick() {
  setButtonText('Connect Again');
}
const openInNewTab = url => {
  window.open(url, '_blank', 'noopener,noreferrer');
};



return (
<s.Screen>
  <s.Container
      id="bg"
        flex={1}
        ai={"center"}
        style={{backgroundColor: "var(--primary)"}}
        image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}>

          {/*Header*/}
    <ResponsiveWrapperHeader>
      <s.HeaderDiv id="header">
        <div id="headerLogo">
          <StyledImg  src="/config/images/headerLogo.png"/>
        </div>
        <button id="switch" onClick={() => setVisible(!visible)}>{visible ? 'NFT Minting' : 'NFT Staking'}</button>
        <div id="svgbx">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="25" height="25"
	 viewBox="0 0 405.867 405.867"  >
<g>
	<path d="M389.887,0H58.973C26.996,0,0.98,26.016,0.98,57.993v287.823c0,33.112,26.938,60.051,60.051,60.051h328.855
		c8.284,0,15-6.716,15-15V15C404.887,6.716,398.171,0,389.887,0z M58.973,30h315.914v55.985h-23.314V57.993c0-5.523-4.478-10-10-10
		H32.834C36.869,37.483,47.061,30,58.973,30z M331.572,85.985h-272.6c-11.912,0-22.104-7.483-26.139-17.992h298.738V85.985z
		 M61.031,375.867c-16.57,0-30.051-13.481-30.051-30.051V108.761c8.305,4.598,17.846,7.224,27.992,7.224h315.914v74.778h-63.772
		c-30.417,0-55.163,24.746-55.163,55.163s24.746,55.163,55.163,55.163h63.772v74.778H61.031z M374.887,281.089h-63.772
		c-19.389,0-35.163-15.774-35.163-35.163c0-19.389,15.774-35.163,35.163-35.163h63.772V281.089z" fill="#ffffff"/>
	<path d="M297.166,245.922c0,3.95,1.601,7.82,4.391,10.61s6.66,4.39,10.609,4.39c3.95,0,7.811-1.6,10.601-4.39
		c2.8-2.79,4.399-6.66,4.399-10.61c0-3.95-1.6-7.81-4.399-10.6c-2.79-2.8-6.65-4.4-10.601-4.4c-3.949,0-7.819,1.6-10.609,4.4
		C298.767,238.112,297.166,241.982,297.166,245.922z" fill="#ffffff"/>
</g>
            </svg>
            <h1 id="address">{walletAddress}</h1>
        </div>
        <div id="buttons">
          <div>
            <button id="home" onClick={() => openInNewTab('https://safeonechain.com/')} >SafeOne Home</button>
          </div>
          <div>
            <WalletBox id="walletBox" onClick={(e) => { e.preventDefault(); dispatch(connect()); getData(); handleClick(); }}>{buttonText}</WalletBox>
          </div>
        </div>
      </s.HeaderDiv>
    </ResponsiveWrapperHeader>



   {/* //STAKING SHOWS AFTER PUSH */}
<div id="rowOne" style={{display: visible ? 'flex' : 'none'}}>
  <div id="firstCard" >
    {/* <StyledImgTitle id="title" src="/config/images/title.png" /> */}
<StyledImgForCard id="cardGroup" src="/config/images/grouping.png" />

{/* Start of DAPP */}
<div id="BigBox">
<s.BOX
         id="bigBox"
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{
            
              // backgroundColor: "rgb(255 255 255 / 20%)",
              padding: 24,
              borderRadius: 24,
              boxShadow: "0px 10px 11px 2px rgba(0,0,0,0.7)",
              
            }}

          ><s.TextDescription
          style={{ textAlign: "center", color: "var(--accent-text)" }}
        >
        </s.TextDescription>
        <s.SpacerSmall />
        {blockchain.account === "" ||
        blockchain.smartContract === null ? (
          <s.Container ai={"center"} jc={"center"}>
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
              }}
            >
              Connect to the {CONFIG.NETWORK.NAME} network
            </s.TextDescription>
            <StyledButton
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData(); 
                      }}
                    >
                      CONNECT

                    </StyledButton>
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                     <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerSmall />
                    
                    <s.Container  ai={"center"} jc={"center"} fd={"column"}>
                     
                      <button  id="button"
                    
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          Approve();
                          getData();
                        }}
                      >
                        {claimingNft ? "Approving" : "Approve"}
                    
                        <span id="tooltip"><b>APPROVE</b> ONLY NEEDED THE FIRST TIME YOU STAKE</span>  
                        
                        <MobileView>
                        <span id="text2"><b>APPROVE </b>ONLY NEEDED THE FIRST TIME YOU STAKE</span>
                        </MobileView>
                      </button>
                     
                     <s.SpacerSmall />
                    </s.Container>
                    <s.SpacerSmall />

                  </>
                )}
            <s.SpacerMedium />

            { blockchain.account === "" || blockchain.smartContract === null ? (
            <>
            </>
          ) : (
            <>
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                  </s.Container>
                ) : (
                  <>
                     <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                    BUSD Earned : {RewardMSG}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {UnStakeMSG} {StakeMSG} {HavestMSG} {UnStakeAllMSG}
                    </s.TextDescription>
                    <s.SpacerMedium />


                    <s.Container ai={"center"} jc={"center"} fd={"row"}>
                    <input style={{ width: 125, height: 25}}
                          onChange={ e => settokens(e.target.value)}
                          value={tokens}
                          placeholder="TokenID"
                          type="number"
                          min="1"
                          max="10000"
                          ref={tokensInputRef}
                        /> 
                    </s.Container>
                    <s.SpacerMedium />
                    <s.Container ai={"flex-start"} jc={"center"} fd={"row"}>
                    <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          Stake();
                          getData();
                          setUnMSG(null);
                          setHarvestMSG(null);
                          setUnStakeAllMSG(null);
                        }}
                      >
                        {StakeNFT ? "Staking..." : "Stake"}
                        
                      </StyledButton>
                      <s.SpacerSmall />
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          StakeAll();
                          getData();
                          setUnMSG(null);
                          setHarvestMSG(null);
                          setUnStakeAllMSG(null);
                        }}
                      >
                        {UnStakeNFT ? "Staking..." : "Stake All"}
                        
                      </StyledButton>
                      <s.SpacerSmall />
                      <StyledButton
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          unstakeallnfts();
                          getData();
                          setMSG(null);
                          setHarvestMSG(null);
                        }}
                      >
                        {UnStakeAllNFT ? "Unstaking" : "UnstakeAll"}
                        
                      </StyledButton>
                      </s.Container>
                      <s.SpacerSmall />
                      <s.Container ai={"center"} jc={"center"} fd={"column"}>
                        
                      
                       <StyledButton 
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          Harvest();
                          getData();
                          setUnMSG(null);
                          setMSG(null);
                        }}
                        style={{ width:200 }}
                      >
                        {ClaimReward ? "Claiming..." : "Claim Your Reward"}
                        
                      </StyledButton>
                      
                      <s.SpacerMedium />
                    </s.Container>
                    </>
                )}
           
          </>)}
      </s.BOX>  
</div>
</div>

{/*start of second column at 30%*/}
        <div id="secondCard">        
          <div id="spinningCoin">
            <StyledImgSpinningCoin  src="/config/images/logo.gif" />
          </div>
          <div id="stakedNFTs">
          <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                     Your Staked NFTs: {CheckMSG}
          </s.TextDescription>
          </div>
          <div id="totalStaked">
             <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                     Total Staked NFTs: {data.tokensStaked}
            </s.TextDescription>
          </div>
          <div id="contract">
            <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {/* <StyledLink id="bscscan"href={CONFIG.SCAN_LINK}>
                        BSCSCAN
                      </StyledLink> */}
            </s.TextDescription>
          </div>
    </div>
{/*enf if row 1*/}    
  </div>



  <div id="rowOne" style={{display: visible ? 'none' : 'flex'}}>
  
<div id="firstCard">
<p id="mintTitle"  > SafeOne Lifetime Insurance NFTs</p>

<BrowserView id="cardGroup">
<StyledImgForCard src="/config/images/grouping.png" />
</BrowserView>

<MobileView id="mobileImgBox">
  <StyledImgForCard id="mobileImg" src="/config/images/phone.png" />
</MobileView>

<div id="BigBox"
                                               
                                                  // flex={1}
                                                  // jc={"center"}
                                                  // ai={"center"} 
                                                  // style={{
                                                  //   padding: 24,
                                                  //   borderRadius: 24,
                                                  //   border: "0px dashed var(--secondary)",
                                                  
                                                  // }}
                                                >
                                                
                                                  <s.TextDescription
                                                    style={{
                                                      textAlign: "center",
                                                      color: "var(--primary-text)",
                                                    }}
                                                  >
                                                
                                                  </s.TextDescription>
                                                  <span
                                                    style={{
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                
                                                
                                              
                                                  </span>

                                              
                                                  
                                                  <s.SpacerXSmall />
                                                  {Number(TotalSupply) >= CONFIG.MAX_SUPPLY ? (
                                                    <>
                                                      <s.TextTitle id="ended"
                                                        style={{ textAlign: "center", color: "var(--accent-text)" }}
                                                      >
                                                        The sale has ended.
                                                      </s.TextTitle>

                                                      <s.SpacerXSmall />
                                                      <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                                                        {CONFIG.MARKETPLACE}
                                                      </StyledLink>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <s.TextTitle
                                                        style={{ textAlign: "center", color: "var(--accent-text)" }}
                                                      >
                                                    SafeOne Lifetime Insurance NFTs cost 1 BNB!!!
                                                      </s.TextTitle>
                                                      <s.SpacerXSmall />
                                                    
                                                      <s.SpacerXSmall />
                                                  
                                                      
                                                      
                                                      {blockchain.account === "" ||
                                                        blockchain.smartContract === null ? (
                                                        <s.Container ai={"center"} jc={"center"}>
                                                      
                                                          <s.SpacerXSmall />
                                                          <StyledButton
                                                            onClick={(e) => {
                                                              e.preventDefault();
                                                              dispatch(connect());
                                                              getData();
                                                            } }
                                                          >
                                                            CONNECT
                                                          </StyledButton>
                                                          {blockchain.errorMsg !== "" ? (
                                                            <>
                                                              <s.SpacerXSmall />
                                                              <s.TextDescription
                                                                style={{
                                                                  textAlign: "center",
                                                                  color: "var(--accent-text)",
                                                                }}
                                                              >
                                                                {blockchain.errorMsg}
                                                              </s.TextDescription>
                                                            </>
                                                          ) : null}

                                      <s.TextDescription id="connect"
                                                            style={{
                                                              textAlign: "center",
                                                              color: "var(--primary)",
                                                            }}
                                                          >
                                                            Connect to the {CONFIG.NETWORK.NAME} network
                                                          </s.TextDescription>
      
                                                        </s.Container>
                                                      ) : (
                                                        
                                                        <>
   
  {/* <CrossmintPayButton
                clientId="49a1b1bb-8ff8-4551-be5d-46c1a4cda743"
                mintConfig={{"type":"erc-721","totalPrice":"0.00080","_mintAmount":"1"}}
           
                mintTo= {signerAddress}
            /> */}
                                                          <s.TextDescription
                                                            style={{
                                                              textAlign: "center",
                                                              color: "var(--accent-text)",
                                                            }}
                                                          >
                                                            {feedbackMint}
                                                          </s.TextDescription>
                                                          <s.SpacerXSmall />
                                                          <s.Container ai={"center"} jc={"center"} fd={"row"}>
                                                            {/* <StyledRoundButton
                                                              style={{ lineHeight: 0.4 }}
                                                              disabled={claimingNft ? 1 : 0}
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                decrementMintAmount();
                                                              } }
                                                            >
                                                              -
                                                            </StyledRoundButton>
                                                            <s.SpacerXSmall />
                                                            <s.TextDescription
                                                              style={{
                                                                textAlign: "center",
                                                                color: "var(--accent-text)",
                                                              }}
                                                            >
                                                              {mintAmount}
                                                            </s.TextDescription>
                                                            <s.SpacerXSmall /> */}
                                                            {/* <StyledRoundButton
                                                              disabled={claimingNft ? 1 : 0}
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                incrementMintAmount();
                                                              } }
                                                            >
                                                              +
                                                            </StyledRoundButton> */}
                                                          </s.Container>
                                                          <s.SpacerXSmall />
                                                          <s.Container ai={"center"} jc={"center"} fd={"row"}>
                                                            <StyledButton
                                                              disabled={claimingNft ? 1 : 0}
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                claimNFTs();
                                                                getData();
                                                              } }
                                                            >
                                                              {claimingNft ? "BUSY" : "BUY"}
                                                            </StyledButton>

                                                            
                                                            
                                                          </s.Container>
                                                          <s.SpacerLarge />
                                                          <s.SpacerLarge />
                                                          <div id="whitelist">
                                                            <s.TextTitle
                                                        style={{ textAlign: "center", color: "var(--accent-text)" }}
                                                      >
                                                    White Listed addresses can mint their NFT below
                                                      </s.TextTitle>
                                                      <StyledButton
                                                       disabled={claimingNft ? 1 : 0}
                                                       onClick={(e) => {
                                                         e.preventDefault();
                                                         claimWhiteListNFTs();
                                                         getData();
                                                       } }
                                                     >
                                                       {claimingNft ? "BUSY" : "WHITELIST MINTING"}
                                                     </StyledButton>

                                                            </div>
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                  <s.SpacerXSmall />
                                                </div>
</div>

<div id="secondCard">

<div id="count">
                                                          <s.TextTitle
                                                            style={{
                                                              textAlign: "center",
                                                              fontSize: 50,
                                                              fontWeight: "bold",
                                                              color: "var(--counter-text)",
                                                            }}
                                                          >
                                                            {TotalSupply} / {CONFIG.MAX_SUPPLY}
                                                          </s.TextTitle> 
                                                          <div id="minted"> &nbsp; MINTED</div>
                                                        </div>
                                                        <div id="spinningCoin">
            <StyledImgSpinningCoin  src="/config/images/SafeOneLifetimeInsuranceNFT.gif" />
          </div>
</div>
  </div>





  <div id="rowTwo" >


    
    <div id="tokenRow">
      <div id="tokens-txt">
        Tokens
      </div>


{/*name/symbol container*/}
    <div id="nameSymbol-box">
      <div id="name-txt">
        Name/Symbol
      </div>
      <div id="tokens-symbols">
        Binance Smart Chain / BNB
      </div>
      <div id="tokens-symbols">
        Binance USD / BUSD
      </div>
      <div id="tokens-symbols">
       SafeOne Chain/ SAFO
      </div>
      {/* <div id="recession-txt">
        Recession Coin / ECON
      </div> */}
    </div>

<div id="balances-box">
<div id="balance-txt">
      Balance
      </div>
      <div id="bal">
      </div>
      <div id="busd"></div>
      <div id="luna"></div>
      {/* <div id="recession"></div> */}
</div>
  
</div>



  
<div id="nft-box">
   <div id="nfts-owned">
    SafeOne NFTs
   </div>
   <div id="youown">
    You Own &nbsp;
   <div id="nft"> ... </div>
   &nbsp; SafeOne Lifetime Insurance NFTs
   </div>
   <div id="contractbox">
    NFT contract: &nbsp;
   
   <div id="contract">
   <a href="https://bscscan.com/address/0xBaAe8ace96915D2988CdEcd520E3C67769239627#code" target="blank">
   0xBaAe8ace96915D2988CdEcd520E3C67769239627
   </a>
   </div>
  
   </div>
   </div>
    </div>
   
    <StyledImgYours id="yours" src="/config/images/yournfts.png" />


<div id="rowThree">



<Nftpuller />
  





</div>





  </s.Container>


</s.Screen>
    
  );
}

export default App;
